import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import { bootstrapMsal } from "./auth/msal";
import { initTelemetry } from "./telemetry";

import "./styles/theme.css";
import "./styles/app.css";

// Roboto via CDN -- cached aggressively at the CDN, blocks paint only for
// the first uncached visit. For tighter Lighthouse scores, self-host later.
const link = document.createElement("link");
link.rel = "stylesheet";
link.href = "https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap";
document.head.appendChild(link);

const preconnect = document.createElement("link");
preconnect.rel = "preconnect";
preconnect.href = "https://fonts.gstatic.com";
preconnect.crossOrigin = "anonymous";
document.head.appendChild(preconnect);

initTelemetry();

void bootstrapMsal().then(() => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  );
});
